import { FIRE_DEPARTMENT_IDS, LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Birmingham Fire Department Questionaire": {
    parameters: {
      linkUrls: [
        "https://fulfillmentguide.helpkit.so/chemicals/6NmwbK2GNFS9Az6DhF7Xez/alabama/76aZY8ybT6GdVzcPJgqjJ8#local-nuances",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: false,
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.AL.BIRMINGHAM,
          name: "Birmingham Fire & Rescue",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "AL",
  },
  "Morgan County LEPC Questionaire": {
    parameters: {
      linkUrls: ["https://morgancountyema.readyop.com/fs/4caK/6bdaa808"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.AL.MORGAN,
          name: "Morgan",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "AL",
  },
  "Homewood Fire Department Questionaire": {
    parameters: {
      linkUrls: [
        "https://fulfillmentguide.helpkit.so/chemicals/6NmwbK2GNFS9Az6DhF7Xez/alabama/76aZY8ybT6GdVzcPJgqjJ8#local-nuances",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: false,
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.AL.HOMEWOOD,
          name: "Homewood Fire Department",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "AL",
  },
};
